








































































































































import Vue from 'vue';
import { Component, Inject } from 'vue-property-decorator';
import LocalDateTime from '@/types/localdatetime';
import { KFiSelector } from '@kasasa/fbase-components';
import ReloadJobDialog from '@/components/reloadjobdialog.vue';
import TextBoxDatePicker from '@/components/textboxdatepicker.vue';
import UserSelector from '@/components/userselector.vue';
import ReloadResource from '@/api/reload/ReloadResource';
import { ReloadEntry } from '@/api/reload/ReloadEntry';
import { ReloadDataTableEntry } from '@/api/reload/ReloadDataTableEntry';
import { Alert, NoticeClass } from '@kasasa/fbase-components/lib';
import UserResource from '@/api/user/UserResource';
import { reloadReasons } from '@/api/reload/reloadreasons';
import { reloadStatuses } from '@/api/reload/reloadstatuses';
import { Envelope } from '@/types/envelope';
import { DataTablePagingConfig } from '@/types/datatablepagingconfig';
import { RecompArgument } from '../api/reload/RecompArgument';

@Component({
  components: {
    'reload-job-dialog': ReloadJobDialog,
    'fi-selector': KFiSelector,
    'user-selector': UserSelector,
    'text-box-date-picker': TextBoxDatePicker,
  },
})


export default class ReloadHistory extends Vue {
	loading: boolean = true;

	KRP_REPORTING_URL_PREFIX: string = 'https://krp-rewards-processing.';

	@Inject('ReloadResource')
	private reloadResource!: ReloadResource;

	@Inject('UserResource')
	private userResource!: UserResource;

	headers: any = [
	  { text: 'FI ID', value: 'fiId', width: '100px' },
	  { text: 'Reload Origin', value: 'reloadPoint' },
	  {
	    text: 'Job Execution Date Range',
	    value: 'sortableStartDate',
	    width: '200px',
	  },
	  { text: 'Time Initiated', value: 'sortableInitiated', width: '100px' },
	  { text: 'User', value: 'userName' },
	  { text: 'Reason', value: 'friendlyReason', width: '100px' },
	  { text: 'Status', value: 'status' },
	  { text: 'Cancel Previous Reloads', value: 'cancelExistingReloads' },
	  { text: 'Reward Processing Enabled', value: 'friendlySkipRewardsProcessing' },
	   { text: 'Includes Recomp', value: 'includesRecomp', sortable: false },
	  { text: 'Details', value: 'details' },
	];

	errorMessage: string = '';

	items: ReloadDataTableEntry[] = [];

	// pagination options
	totalNumberOfResults:number = 0;

	rowsPerPage:number = 25;

	currentDisplayedPage:number = 1;

	defaultSortedColumn = 'sortableInitiated';

	currentlySortedColumn:string = this.defaultSortedColumn;

	sortDirections:string[] = ['DESC', 'ASC'];

	currentlySortedDirection:string = this.sortDirections[0];

	currentDataTablePagingConfig!:DataTablePagingConfig;
	// end of pagination options

	selectedFi: string = '';

	selectedUser: String = '';

	options: any = {
	  sortBy: [this.defaultSortedColumn],
	  sortDesc: [true],
	};

	footerProps: any = {
	  'items-per-page-options': [25, 50, 100, { value: -1, text: 'All' }],
	};

	showFilter: boolean = false;

	dateSearchTypes: Map<string, string> = new Map([
	  ['PROCESSING', 'Core Processing Date'],
	  ['INITIATED', 'Date Initiated'],
	]);

	filter: any = ReloadHistory.getClearFilter();

	reloadJobEntrySelected:ReloadDataTableEntry = new ReloadDataTableEntry();

	mounted() {
	  this.loadJobs(false);
	}

	onPageChange(eventPageConfig:DataTablePagingConfig) {
	  // if anything changed on the page display values, reload the data
	  if (this.didPageDisplayConfigChange(eventPageConfig)) {
	    this.currentDataTablePagingConfig = eventPageConfig;
	    this.loadJobs(true);
	  }
	}

	didPageDisplayConfigChange(newPageConfig:DataTablePagingConfig): boolean {
	  if (this.currentDataTablePagingConfig) {
	  return this.currentDataTablePagingConfig.itemsPerPage !== newPageConfig.itemsPerPage
		  || this.currentDataTablePagingConfig.page !== newPageConfig.page;
	  }
	  return true;
	}

	onSortByChange(sortColumnSelected:object) {
	  this.currentlySortedColumn = sortColumnSelected.toString();
	  this.loadJobs(true);
	}

	onSortDescChange(isSortDesc:object) {
	  if (this.currentlySortedColumn.toString() === 'includesRecomp') {
		  // do nothing
		  return;
	  }
	  this.currentlySortedDirection = (isSortDesc.toString() === 'true')
	  	 ? this.sortDirections[0] : this.sortDirections[1];
	  this.loadJobs(true);
	}

	clearFilter() {
	  this.filter = ReloadHistory.getClearFilter();
	}

	static getClearFilter() {
	  return {
	    selectedFi: {},
	    selectedUser: {},
	    dateSearchType: undefined,
	    startDateString: undefined,
	    endDateString: undefined,
	  };
	}

	toggleFilter() {
	  this.showFilter = !this.showFilter;
	  if (!this.showFilter) {
	    this.clearFilter();
	    this.loadJobs(false);
	  }
	}

	resetPageAndApplyFilter() {
	  if (this.currentDisplayedPage !== 1) {
	    // reset view to page 1, which will automatically reload page
	    this.currentDisplayedPage = 1;
	  } else {
	    this.loadJobs(true);
	  }
	}

	loadJobs(useFilter: boolean) {
	  this.loading = true;
	  let url: string = '';

	  if (useFilter) {
	    url += this.buildFilterParams();
	  }

	  url += this.addPageParams(url);

	  this.reloadResource
	    .getAll(url)
	    .then((envelope: Envelope) => {
	      this.totalNumberOfResults = envelope.paging.size;
	      this.buildReloadTableEntries(envelope.data);
	      this.loading = false;
	    })
	    .catch((error: any) => {
	      this.showError(error);
	      this.loading = false;
	    });
	  this.errorMessage = '';
	}

	addPageParams(url:string) : string {
	  let pageParams:string = '';
	  if (url.includes('?')) {
	    pageParams += '&';
	  } else {
	    pageParams += '?';
	  }

	  const sortColumnName = ReloadHistory.getSortDbColumnFromSortedDisplayColumn(this.currentlySortedColumn);
	  pageParams += `pageSize=${this.rowsPerPage}&pageIndex=${this.currentDisplayedPage - 1}`
	  + `&pageSortColumn=${sortColumnName}&pageSortDirection=${this.currentlySortedDirection}`;

	  return pageParams;
	}

	static getSortDbColumnFromSortedDisplayColumn(displayColumn:string):string {
	  // mapping between display column name and the backend table column name
	  if (displayColumn === 'sortableInitiated') {
	    return 'initiated';
	  }
	  if (displayColumn === 'sortableStartDate') {
		  return 'startDate';
	  }
	  if (displayColumn === 'userName') {
		  return 'userId';
	  }
	  if (displayColumn === 'friendlyReason') {
		  return 'reason';
	  }
	  if (displayColumn === 'friendlySkipRewardsProcessing') {
		  return 'skipRewardsProcessing';
	  }
	  return displayColumn;
	}

	buildReloadTableEntries(reloadItems: ReloadEntry[]) {
	  this.items = [];
	  for (let i = 0; i < reloadItems.length; i++) {
	    this.items.push(ReloadHistory.buildTableEntry(reloadItems[i]));
	  }
	}

	static buildTableEntry(item: ReloadEntry): ReloadDataTableEntry {
	  const tableEntry: ReloadDataTableEntry = {
	    id: item.id,
	    fiId: item.fiId,
	    reloadPoint: item.reloadPoint,
	    dateRange: `${new LocalDateTime(
	      item.startDate,
	    ).toFriendlyDateString()} - ${new LocalDateTime(
	      item.endDate,
	    ).toFriendlyDateString()}`,
	    startDate: item.startDate,
	    endDate: item.endDate,
	    initiated: item.initiated,
	    userName: item.userName,
	    reason: item.reason,
	    status: item.status,
	    cancelExistingReloads: item.cancelExistingReloads,
	    details: item.details,
	    skipRewardsProcessing: item.skipRewardsProcessing,
	    sortableStartDate: new LocalDateTime(item.startDate).toDate().getTime(),
	    friendlyInitiated: new LocalDateTime(
	      item.initiated,
	    ).toFriendlyDateTimeString(),
	    sortableInitiated: new LocalDateTime(item.initiated).toDate().getTime(),
	    friendlyTime: item.friendlyTime,
	    friendlyReason: reloadReasons.get(item.reason),
	    friendlyStatus: reloadStatuses.get(item.status),
	    friendlySkipRewardsProcessing: item.skipRewardsProcessing ? 'No' : 'Yes',
	    includesRecomp: !!((item.recompArgumentList && item.recompArgumentList.length > 0)),
	    recompArgumentList: item.recompArgumentList,
	  };
	  if (tableEntry.friendlyReason === undefined) {
	    tableEntry.friendlyReason = tableEntry.reason;
	  }
	  return tableEntry;
	}

	onNewStartDate(date: string) {
	  this.filter.startDateString = date;
	  const localDate: LocalDateTime = new LocalDateTime(date);
	}

	onNewEndDate(date: string) {
	  this.filter.endDateString = date;
	  const localDate: LocalDateTime = new LocalDateTime(date);
	}

	buildFilterParams() {
	  let params = '';

	  if (
	    this.filter.selectedFi
			&& this.filter.selectedFi.fiId
	  ) {
	    params = ReloadHistory.addFilterParam(
	      params,
	      'fiId',
	      this.filter.selectedFi.fiId,
	    );
	  }

	  if (
	    this.filter.selectedUser
			&& this.filter.selectedUser.id
	  ) {
	    params = ReloadHistory.addFilterParam(
	      params,
	      'userId',
	      this.filter.selectedUser.id,
	    );
	  }

	  let dateFromParam: string = '';
	  let dateToParam: string = '';

	  if (this.filter.dateSearchType) {
	    if (this.filter.dateSearchType[0] === 'PROCESSING') {
	      dateFromParam = 'coreProcessingDateMin';
	      dateToParam = 'coreProcessingDateMax';
	    } else if (this.filter.dateSearchType[0] === 'INITIATED') {
	      dateFromParam = 'initiatedDateMin';
	      dateToParam = 'initiatedDateMax';
	    }
	  }

	  if (dateFromParam !== '') {
	    if (this.filter.startDateString) {
	      params = ReloadHistory.addFilterParam(
	        params,
	        dateFromParam,
	        this.filter.startDateString,
	      );
	    }

	    if (this.filter.endDateString) {
	      params = ReloadHistory.addFilterParam(
	        params,
	        dateToParam,
	        this.filter.endDateString,
	      );
	    }
	  }

	  return params;
	}

	static addFilterParam(params: string, name: string, value: string) {
	  let newParams: string = params;

	  if (newParams.length === 0) {
	    newParams += '?';
	  } else {
	    newParams += '&';
	  }

	  newParams += `${name}=${value}`;
	  return newParams;
	}

	hasFilter() {
	  return (
	    (this.filter.selectedFi
				&& this.filter.selectedFi.fiId)
			|| this.filter.startDateString
			|| this.filter.endDateString
			|| (this.filter.selectedUser
				&& this.filter.selectedUser.id)
	  );
	}

	showError(error: any) {
	  if (error.response && error.response.data && error.response.data.entity) {
	    this.setError(error.response.data.entity);
	  } else {
	    this.setError('An unexpected error occurred.');
	  }
	}

	setError(message: string) {
	  const al = new Alert(message, NoticeClass.ERROR);
	  al.setTimeout(5000);
	  this.$store.dispatch('notices/add', al);
	}

	onReloadRecompDetailButtonClick(fiId:string, reloadId: string) {
	  let url:string = this.getReportingWebUrl();
	  url += `${fiId}/incomingredirect/recompsummary/${reloadId}`;
	  window.location.replace(url);
	}

	getReportingWebUrl():string {
	  let krpRewardsProcessingRecompUrl = this.KRP_REPORTING_URL_PREFIX;
	  if (window.location.href.indexOf('localhost') !== -1 || window.location.href.indexOf('.dev.') !== -1) {
	    krpRewardsProcessingRecompUrl += 'dev.';
	  } else if (window.location.href.indexOf('.uat.') !== -1) {
	    krpRewardsProcessingRecompUrl += 'uat.';
	  }

	  krpRewardsProcessingRecompUrl += 'kasasaonline.com/#/';

	  return krpRewardsProcessingRecompUrl;
	}

	onReloadJobDblClicked(event:any, clickedItem:any) {
	  this.reloadJobEntrySelected = clickedItem.item;
	}

	onReloadDialogClosed() {
	  this.reloadJobEntrySelected = new ReloadDataTableEntry();
	}
}
